// Getters
export const PRT_IS_ERROR = "party/statePrtIsError";
export const PRT_IS_LOADING = "party/statePrtIsLoading";
export const PRT_GET_DATA = "party/statePrtData";
export const PRT_GET_FILTER = "party/statePrtFilter";

//Mutations
export const PRT_MUTATION_FILTER_EMAIL = "party/statePrtFilterEmail";
export const PRT_MUTATION_CLEAR_FILTER = "party/statePrtFilterClear";

// Actions
// export const PRT_ACTION_DATA = 'party/statePrtData';
export const PRT_ACTION_FILTER = "party/statePrtSearchByFilter";
export const PRT_ACTION_FILTER_EMAIL = "party/statePrtFilterEmail";
export const PRT_ACTION_CLEAR_FILTER = "party/statePrtFilterClear";
export const PRT_ACTION_GET_ORGS = "party/statePrtGetOrgs";



// WEBPACK FOOTER //
// ./src/store/types_party.js